<div class="save-line">
  <h3 i18n='@@filter'>Filtro</h3>
  <mat-divider style="flex: 1 1 auto; margin: 0 25px;"></mat-divider>
  <button mat-flat-button class="btn-active-green" [disabled]="!form?.valid" (click)="applicaFiltri()">
    <span i18n='@@apply'>Applica</span>
  </button>
</div>

<!-- FILTER FORM -->
<form [formGroup]="form" style="display: flex; justify-content: space-around; flex-flow: row wrap;">
  <!-- DATA -->
  <mat-form-field appearance="outline" style="flex-grow: 2; margin-right: 10px;">
    <input matInput [matDatepicker]="datePick" placeholder="Data transazione" i18n-placeholder="@@dataOperations"
           formControlName="data">
    <mat-datepicker-toggle matSuffix [for]="datePick">
      <mat-icon matDatepickerToggleIcon svgIcon="calendario" class="stats-icon dark-icon"></mat-icon>
    </mat-datepicker-toggle>
    <mat-datepicker #datePick></mat-datepicker>
  </mat-form-field>

  <!-- CERCA -->
  <mat-form-field floatLabel="never" appearance="outline" style="flex-grow: 2; margin-right: 10px;">
    <input *ngIf="filterBy !== 'amount'" matInput type="text" placeholder="Cerca"
           i18n-placeholder="@@placeholder-Search" formControlName="cerca">
    <input *ngIf="filterBy === 'amount'" matInput type="tel" appCurrencyMask placeholder="Cerca"
           i18n-placeholder="@@placeholder-Search" formControlName="cerca">
  </mat-form-field>

  <!-- FILTRO -->
  <mat-form-field appearance="outline" style="flex-grow: 0; margin-right: 10px;">
    <mat-select placeholder="Filtro" i18n-placeholder="@@filter" [(ngModel)]="filterBy"
                [ngModelOptions]="{standalone: true}" (selectionChange)="selectChange($event)">
      <mat-option *ngFor="let f of filters" [value]="f">{{ mapFilter[f] }}</mat-option>
    </mat-select>
  </mat-form-field>
</form>

<!-- TABLE -->
<div style="margin: 15px 0;">
  <table mat-table [dataSource]="paymentsSource" class="transactionTable" matSort
         matSortActive="createdAt" matSortDirection="desc" matSortDisableClear>

    <!-- DATE -->
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n='@@th-Date'>Data</th>
      <td mat-cell *matCellDef="let operation" class="date">
        {{ operation.date.date }} <span>{{ operation.date.time }}</span>
        <span class="hide-ms" style="font-size: 11px">:{{ operation.date.ms }}</span>
      </td>
    </ng-container>

    <!-- STATE -->
    <ng-container matColumnDef="state">
      <th mat-header-cell *matHeaderCellDef i18n='@@th-State'>Stato</th>
      <td mat-cell *matCellDef="let operation">
        <mat-icon *ngIf="operation.state==='MISSING_DATA'" class="svg-icon-status" svgIcon="failed"
                  matTooltip="{{ operation.errorDesc }}" matTooltipClass="tooltip"
                  matTooltipPosition="before"></mat-icon>

        <mat-icon *ngIf="operation.state==='failed'" class="svg-icon-status" [svgIcon]="operation.state"
                  matTooltip="Pagamento fallito: {{ operation.errorDesc }}" matTooltipClass="tooltip"
                  matTooltipPosition="before" i18n-matTooltip="@@matTooltip-PaymentFailed"></mat-icon>

        <mat-icon *ngIf="operation.state==='INIT'" class="svg-icon-status" [svgIcon]="operation.state"
                  matTooltip="Pagamento inizializzato" matTooltipClass="tooltip"
                  matTooltipPosition="before" i18n-matTooltip="@@matTooltip-InitializedPayment"></mat-icon>

        <mat-icon *ngIf="operation.state==='PENDING'" class="svg-icon-status" [svgIcon]="operation.state"
                  matTooltip="Pagamento in attesa" matTooltipClass="tooltip"
                  matTooltipPosition="before" i18n-matTooltip="@@matTooltip-PaymentonHold"></mat-icon>

        <mat-icon *ngIf="operation.state==='PROGRESS'" class="svg-icon-status" [svgIcon]="operation.state"
                  matTooltip="Pagamento preso in carico dal gateway" matTooltipClass="tooltip"
                  matTooltipPosition="before" i18n-matTooltip="@@matTooltip-PaymentTakeninCharge"></mat-icon>

        <mat-icon *ngIf="operation.state==='success'" class="svg-icon-status" [svgIcon]="operation.state"
                  matTooltip="Pagamento completato" matTooltipClass="tooltip"
                  matTooltipPosition="before" i18n-matTooltip="@@matTooltip-PayCompleted"></mat-icon>

        <mat-icon *ngIf="operation.state==='RECURRENT'" class="svg-icon-status" [svgIcon]="operation.state"
                  matTooltip="Pagamento ricorrente" matTooltipClass="tooltip"
                  matTooltipPosition="before"></mat-icon>
      </td>
    </ng-container>

    <!-- 3DS -->
    <ng-container matColumnDef="state_3ds">
      <th mat-header-cell *matHeaderCellDef>3DS</th>
      <td mat-cell *matCellDef="let operation">
        <mat-icon *ngIf="operation?.is3dEnabled" class="svg-icon-3ds" [svgIcon]="operation.state_3ds"></mat-icon>
      </td>
    </ng-container>

    <!-- AMOUNT -->
    <ng-container matColumnDef="amount">
      <th mat-header-cell *matHeaderCellDef i18n='@@th-Amount' class="centredContent">Importo</th>
      <td mat-cell *matCellDef="let operation" class="centredContent">{{ operation.amount }} {{ operation.currency }}</td>
    </ng-container>

    <!-- CIRCUIT -->
    <ng-container matColumnDef="circuit">
      <th mat-header-cell *matHeaderCellDef i18n='@@th-Circuit' class="centredContent">Circuito</th>
      <td mat-cell *matCellDef="let operation" class="centredContent">
        <img *ngIf="operation.circuit" class="circuiti" [src]="'assets/images/icons/' + operation.circuit + '.png'" alt="circuit-icon">
      </td>
    </ng-container>

    <!-- WALLET TOKEN -->
    <ng-container matColumnDef="wallet_token">
      <th mat-header-cell *matHeaderCellDef class="centredContent">Token Wallet</th>
      <td mat-cell *matCellDef="let operation" class="centredContent">
        <mat-icon *ngIf="operation.wallet_token" svgIcon="token" class="tokenSvg dark-icon"
                  matTooltip="{{ operation.wallet_token }}" matTooltipClass="tooltip"
                  matTooltipPosition="after" (click)="copyToken(operation.wallet_token)">
        </mat-icon>
      </td>
    </ng-container>

    <!-- CARD TOKEN -->
    <ng-container matColumnDef="card_token">
      <th mat-header-cell *matHeaderCellDef i18n="@@th-tokenCard" class="centredContent">Token Carta</th>
      <td mat-cell *matCellDef="let operation" class="centredContent">
        <mat-icon *ngIf="operation.card_token" svgIcon="token" class="tokenSvg dark-icon"
                  matTooltip="{{ operation.card_token }}" matTooltipClass="tooltip"
                  matTooltipPosition="after" (click)="copyToken(operation.card_token)">
        </mat-icon>
      </td>
    </ng-container>

    <!-- NUMBER -->
    <ng-container matColumnDef="number">
      <th mat-header-cell *matHeaderCellDef i18n='@@th-Number' class="card-number">Numero</th>
      <td mat-cell *matCellDef="let operation">{{ operation.number }}</td>
    </ng-container>

    <!-- TRANSACTION ID -->
    <ng-container matColumnDef="transactionID">
      <th mat-header-cell *matHeaderCellDef i18n='@@th-idTransaction'>ID TRANSAZIONE</th>
      <td mat-cell *matCellDef="let operation">{{ operation.transactionID }}</td>
    </ng-container>

    <!-- IDENTIFIERS -->
    <ng-container matColumnDef="identificativi">
      <th mat-header-cell *matHeaderCellDef i18n='@@th-identifiers'>IDENTIFICATIVI</th>
      <td mat-cell *matCellDef="let operation" style="text-align: center;">
        <mat-icon class="dark-icon" svgIcon="open-in-new-tab" style="cursor:pointer;"
                  matTooltip="Payment ID, Shop ID" (click)="openDialogIdentifiers(operation)"></mat-icon>
      </td>
    </ng-container>

    <!-- ACTIONS -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef style="width: 130px;"></th>
      <td mat-cell *matCellDef="let operation">
        <div *ngIf="operation.state !== 'RECURRENT' && !operation.completed && operation.state !== 'PROGRESS'" @inOutButtons>
          <button mat-icon-button (click)="showIntegrationDialog(operation.id)"
                  matTooltip="Visualizza esempi di integrazione per questo pagamento"
                  matTooltipClass="tooltip" matTooltipPosition="above" i18n-matTooltip="@@matTooltip-TypeIntegrations"
                  [disableRipple]="true"
                  [disabled]="!licenses?.wizard && !licenses?.js && !licenses?.android && !licenses?.ios">
            <mat-icon svgIcon="integrazioni" class="actions-icon"></mat-icon>
          </button>

          <button mat-icon-button (click)="redirect(operation.id)" matTooltip="Test di integrazione con Wizard"
                  matTooltipClass="tooltip" matTooltipPosition="above" i18n-matTooltip="@@matTooltip-IntegrationWizard"
                  [disableRipple]="true" [disabled]="!licenses?.wizard">
            <mat-icon svgIcon="test" class="actions-icon"></mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <h3 *ngIf="!paymentsSource?.count" i18n='@@text-noTransactions' style="display: flex; min-height: 250px; align-items: center; justify-content: center;">
    Nessuna transazione presente
  </h3>

  <mat-paginator [length]="paymentsSource?.count || 0" [pageSize]="pageSize"
                 [pageSizeOptions]="pageSizeOptions" [showFirstLastButtons]="true">
  </mat-paginator>
</div>

<div style="text-align: end;">
  <a routerLink="/sandbox/transactions" mat-icon-button class="add-payment" aria-label="Create payment"
     matTooltip="Inizializza pagamento" i18n-matTooltip='@@title-InitializePayment' matTooltipClass="tooltip" matTooltipPosition='above'>
    <mat-icon>add</mat-icon>
  </a>
</div>
